import { FormField, FormItem, FormMessage } from "@/ui/form";
import { SelectUsersAsync } from "@/features/users/components/SelectUsersAsync";
import { SaveReservationData } from "@/features/reserve/utils/utils-reserve";
import { useAuthenticated } from "@gettactic/hooks";
import { FieldErrors, UseFormReturn } from "react-hook-form";
import { UserChip } from "@cmp-src/data-display/chips/UserChip/UserChip";
import React from "react";

type ReserveFieldUsersProps = {
  form: UseFormReturn<any>;
  defaultValue: string[];
  filterValues?: (_: { value: string }) => boolean;
  errors: FieldErrors<SaveReservationData>;
  single?: boolean;
  readonly?: boolean;
  onAfterChange?: () => void;
};
export function ReserveFieldUsers({
  form,
  defaultValue,
  filterValues,
  single = false,
  readonly = false,
  onAfterChange
}: ReserveFieldUsersProps) {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  const isTeamManager =
    !!authenticatedUser?.user?.permissions.includes(
      "schedule:others:managed:add"
    ) && !authenticatedUser?.user?.permissions.includes("schedule:others:add");

  const selectedUsers =
    (form.getValues("users") as
      | { label: string; value: string; profile_photo_url: string }[]
      | undefined) || [];

  return (
    <>
      <FormField
        control={form.control}
        name="users"
        render={({ field }) => (
          <FormItem>
            <SelectUsersAsync
              setInitial={(users) => {
                // Before we can set default values we need to do an async call to retrieve IDs.
                form.setValue("users", users, { shouldValidate: false });
              }}
              onChange={(value) => {
                field.onChange(single ? [value] : value);
                onAfterChange?.();
              }}
              readonly={readonly}
              value={field.value}
              className="w-full text-sm"
              classNames={{
                control: () => "mt-0! border-input! shadow-input",
                singleValue: () => "text-neutral-1000!",
                placeholder: () => "text-muted-foreground!"
              }}
              classNamePrefix="react-select"
              isMulti={!single}
              defaultValue={defaultValue}
              placeholder={
                single ? "Select User" : "Add guests by name or email"
              }
              filterValues={filterValues}
              managed={isTeamManager}
            />
            <FormMessage />
          </FormItem>
        )}
      />
      {!single && (
        <div className="mt-2 flex flex-wrap gap-2">
          {selectedUsers.map((item) => {
            const onCancel = (event: React.MouseEvent) => {
              event.stopPropagation();
              event.preventDefault();
              form.setValue(
                "users",
                selectedUsers.filter((u) => u.value !== item.value),
                { shouldValidate: true }
              );
            };
            return (
              <UserChip
                key={item.value}
                user={{
                  name: item.label,
                  profile_photo_url: item.profile_photo_url
                }}
                onClick={onCancel}
                onCancel={onCancel}
                useColoredBorder
              />
            );
          })}
        </div>
      )}
    </>
  );
}
